import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";

import { QUERY_INVOICING_CONFIG_FOR_PAYER } from "../keys";
import { getInvoicingConfigForPayer } from "../../../services/invoicingConfig";
import { IInvoicingConfig } from "@wingspanhq/payments/dist/interfaces";

export const useQueryInvoicingConfigForPayer = (
  queryConfig?: WSQueryConfig<IInvoicingConfig, unknown>
) =>
  useWSQuery(QUERY_INVOICING_CONFIG_FOR_PAYER, getInvoicingConfigForPayer, {
    retry: false,
    ...queryConfig
  });
